import React from 'react';

function ProfileCard(props) {
  return (
    <div className='w-[250px] h-[280px] bg-gray-50 rounded-lg backdrop-blur-2xl overflow-hidden group relative hover:shadow-xl duration-300 ease-in-out'>
      <div className='absolute w-32 h-32 rounded-full z-0 transition-all left-1/2 -translate-x-1/2 top-7 scale-0 bg-blue-4 group-hover:motion-safe:scale-[85%] duration-500 ease-in-out'>
      </div>
      <div className='absolute rounded-full w-32 h-32 z-10 bg-gray-600 transition-all left-1/2 -translate-x-1/2 top-7 group-hover:motion-safe:scale-75 group-hover:motion-safe:border-8 border-white duration-500 ease-in-out overflow-hidden'>
        <img src={props.img} alt={props.descripccion} className='w-full h-full object-cover object-center'/>
      </div>
      <p className='absolute bottom-[75px] transform left-1/2 -translate-x-1/2 w-max text-2xl'>{props.name}</p>
      <p className='absolute bottom-[55px] transform left-1/2 -translate-x-1/2 w-min' >{props.job}</p>
      <div className='absolute transition-all bottom-0 translate-y-full group-hover:motion-safe:translate-y-0 w-full h-[50px] bg-blue-4 duration-500 ease-in-out flex flex-row text-white text-3xl justify-evenly items-center'>
        <i className="fa-brands fa-facebook-f hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
        <i className="fa-solid fa-envelope hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
        <i className="fa-brands fa-instagram hover:motion-safe:text-yellow-1 duration-300 ease-in-out"></i>
      </div>
    </div>
  )
}

export default ProfileCard